import { AnyAction } from 'redux'
import { produce } from 'immer'
import { PaginateRequest, PaginateResponse } from '../../services/api.service'
import customLabelService from '../../services/customLabel.service'
import { CustomLabelData } from '../../apis/customLabel.api'

interface State extends PaginateRequest {
  result: PaginateResponse<CustomLabelData[]>
  search: string
  sortBy: string
}

const initialState: State = {
  result: {
    data: [],
    total: 0,
    from: null,
    to: null,
    currentPage: 0,
    lastPage: 0
  },
  page: 1,
  limit: 25,
  search: '',
  sortBy: 'desc'
}

export const actions = {
  replaceResult: 'customLabels/replaceResult',
  replaceResultData: 'customLabels/replaceResultData',
  replacePage: 'customLabels/replacePage',
  replaceLimit: 'customLabels/replaceLimit',
  replaceSearch: 'customLabels/replaceSearch',
  replaceSorting: 'customLabels/replaceSorting'
}

export function replaceResult (result: State['result']) {
  return { type: actions.replaceResult, result }
}

export function replaceResultData (data: State['result']['data']) {
  return { type: actions.replaceResultData, data }
}

export function replacePage (page: number) {
  return { type: actions.replacePage, page }
}

export function replaceLimit (limit: number) {
  return { type: actions.replaceLimit, limit }
}

export function replaceSearch (search: string) {
  return { type: actions.replaceSearch, search }
}

export function replaceSorting (sortBy: string) {
  return { type: actions.replaceSorting, sortBy }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.replaceResult:
      return produce(state, draft => {
        draft.result = action.result
        draft.result.data = customLabelService.tableHorizontalData(action.result.data)
      })
    case actions.replaceResultData:
      return produce(state, draft => {
        draft.result.data = action.data
      })
    case actions.replacePage:
      return produce(state, draft => {
        draft.page = action.page
      })
    case actions.replaceLimit:
      return produce(state, draft => {
        draft.limit = action.limit
      })
    case actions.replaceSearch:
      return produce(state, draft => {
        draft.search = action.search
      })
    case actions.replaceSorting:
      return produce(state, draft => {
        draft.sortBy = action.sortBy
      })
    default:
      return state
  }
}
